<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="account-info">
      <div style="font-size: 14px;margin-right: 10px">登录账号：<span style="color: rgb(64, 158, 255);">{{ userName }}</span></div>
<!--      <div id="printer">-->
      <div id="printer" v-if="permissionList.indexOf('admin:print') !== -1">
        当前打印机：
        <el-select v-model="printerSn" placeholder="请选择打印机" @change="handlePrinter" style="width: 110px;">
          <el-option style="height: 28px; line-height: 28px;"
                     v-for="item in printerList"
                     :key="item.printerSn"
                     :label="item.title"
                     :value="item.printerSn">
          </el-option>
        </el-select>
      </div>
      <div id="printer" v-if="permissionList.indexOf('admin:merchantShop') !== -1">
        当前门店：
        <el-select v-model="shopId" placeholder="请选择门店" @change="shopChange" style="width: 110px;">
          <el-option style="height: 28px; line-height: 28px;"
                     v-for="item in shopList"
                     :key="item.value"
                     :label="item.text"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div @click="logout" class="log-out">退出</div>
<!--      <el-dropdown class="avatar-container">-->
<!--        &lt;!&ndash;      <img :src="avatar" style="width: 40px; height: 40px; float: left; margin-top: 5px;">&ndash;&gt;-->
<!--        <el-dropdown-item style="width: 50px; padding: 0; ">-->

<!--        </el-dropdown-item>-->
<!--      </el-dropdown>-->
      <div id="business">
        <span @click="handleOpen" style="display:block;  color: #409EFF;" v-if="!businessState">开始营业</span>
        <span @click="handleClose" style="display:block; color: #f56c6c;" v-else>结束营业</span>
      </div>
    </div>
<!--    <el-dropdown class="avatar-container" style="right: 130px;">-->
<!--      &lt;!&ndash;      <img :src="avatar" style="width: 40px; height: 40px; float: left; margin-top: 5px;">&ndash;&gt;-->
<!--      <el-dropdown-item style="margin-top: 6px; width: 80px; padding: 0; text-align: center">-->
<!--        <span @click="updatePwd" style="display:block; width: 80px; cursor: pointer;">修改密码</span>-->
<!--      </el-dropdown-item>-->
<!--    </el-dropdown>-->

    <!--    <el-dropdown class="avatar-container" trigger="click">-->
    <!--      <div class="avatar-wrapper">-->
    <!--        <img class="user-avatar" :src="avatar">-->
    <!--        <i class="el-icon-caret-bottom"></i>-->
    <!--      </div>-->
    <!--      <el-dropdown-menu class="user-dropdown" slot="dropdown">-->
    <!--        <router-link class="inlineBlock" to="/">-->
    <!--          <el-dropdown-item>-->
    <!--            首页-->
    <!--          </el-dropdown-item>-->
    <!--        </router-link>-->
    <!--        <el-dropdown-item divided>-->
    <!--          <span @click="logout" style="display:block;">退出</span>-->
    <!--        </el-dropdown-item>-->
    <!--      </el-dropdown-menu>-->
    <!--    </el-dropdown>-->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="40%">
      <el-form ref="adminForm" label-width="150px" size="small">
        <el-form-item label="原密码：">
          <el-input v-model="updatePwdData.oldPassword" type="password" style="width: 216px"></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="updatePwdData.newPassword" type="password" style="width: 216px"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：">
          <el-input v-model="updatePwdData.cfPassword" type="password" style="width: 216px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
<!--        <el-button type="primary" @click="handleConfirm" size="small">确 定</el-button>-->
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {getCustomToken, setCustomToken} from '@/utils/auth'
import {merchantPrinter} from '@/api/home'
import {getMerchantShopSelectSList} from '@/api/merchantShop'
import {businessState, updateBusinessState} from '@/api/merchant'

const updatePwdData = {
  oldPassword: null,
  newPassword: null,
  cfPassword: null,
}
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      printerList: [],
      shopList: [],
      printerSn: null,
      businessState: false,
      dialogVisible: false,
      updatePwdData: Object.assign({}, updatePwdData),
      userName: getCustomToken("username"),
      shopId: getCustomToken("shopId"),
      permissionList: getCustomToken("permissionList"),
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  created() {
    this.getPrinterList();
    this.getBusinessState();
    this.getMerchantShopSelectSList()
  },
  methods: {
    shopChange(shopId){
      setCustomToken("shopId", shopId)
    },
    getMerchantShopSelectSList(){
      if (this.permissionList.indexOf('admin:merchantShop') !== -1){
        getMerchantShopSelectSList({
          merchantId: getCustomToken("appid")
        }).then(res => {
          this.shopList = res.data;
        })
      }
    },
    updatePwd(){
      this.dialogVisible = true;
    },
    handleOpen() {
      this.$confirm('确定要开始营业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateBusinessState(1).then(response => {
          location.reload();
        })
      });
    },
    handleClose() {
      this.$confirm('确定要结束营业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateBusinessState(0).then(response => {
          this.getBusinessState();
        })
      });
    },
    handlePrinter(sn) {
      this.printerSn = sn;
      setCustomToken("printerSn", sn);
    },
    getPrinterList() {
      merchantPrinter().then(response => {
        if (response.data != null && response.data.length > 0) {
          this.printerList = response.data;
          let printerSn = getCustomToken("printerSn");
          if (printerSn != null) {
            this.handlePrinter(printerSn)
          } else {
            this.handlePrinter(this.printerList[0].printerSn)
          }
        } else {
          setCustomToken("printerSn", null);
        }
      })
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    getBusinessState() {
      businessState().then(response => {
        this.businessState = response.data;
        if (!response.data) {
          this.handleOpen();
        }
        setCustomToken("businessState", this.businessState)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.account-info{
  position: absolute;
  top: 0;
  right: 50px;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
}
.log-out{
  margin-right: 10rpx;
  font-size: 12px;
  cursor: pointer;
}
#business {
  font-size: 14px;
  color: #606266;
  height: 100%;
  cursor: pointer;
  margin-left: 10px;
}

#printer {
  width: 200px;
  font-size: 14px;
  color: #606266;
  height: 100%;
  display: block;
  margin-right: 10px;
}

#printer .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 80px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue